export enum UserGroup {
  RawMaterialWarehouseAdmin = 'RawMaterialWarehouseAdmin',
}

export enum ProductDevelopmentViewerGroup {
  YarnViewer = 'YarnViewer',
  GreigeViewer = 'GreigeViewer',
  FabricViewer = 'FabricViewer',
  FiberCategoriesViewer = 'FiberCategoriesViewer',
  FabricCategoriesViewer = 'FabricCategoriesViewer',
  ProcessesViewer = 'ProcessesViewer',
  ProcessStepsViewer = 'ProcessStepsViewer',
  ProcessParametersViewer = 'ProcessParametersViewer',
  EngineeringViewer = 'EngineeringViewer',
  ProductRecipeViewer = 'ProductRecipeViewer',
}

export type ProductDevelopmentEditorRoles = ProductDevelopmentEditorGroup | ProductDevelopmentAdminGroup;

export enum ProductDevelopmentEditorGroup {
  GreigeEditor = 'GreigeEditor',
  FabricEditor = 'FabricEditor',
  EngineeringEditor = 'EngineeringEditor',
  ProductRecipeEditor = 'ProductRecipeEditor',
}

export enum ProductDevelopmentAdminGroup {
  YarnAdmin = 'YarnAdmin',
  GreigeAdmin = 'GreigeAdmin',
  FabricAdmin = 'FabricAdmin',
  FiberCategoriesAdmin = 'FiberCategoriesAdmin',
  FabricCategoriesAdmin = 'FabricCategoriesAdmin',
  ProcessesAdmin = 'ProcessesAdmin',
  ProcessStepsAdmin = 'ProcessStepsAdmin',
  ProcessParametersAdmin = 'ProcessParametersAdmin',
  EngineeringAdmin = 'EngineeringAdmin',
  ProductRecipeAdmin = 'ProductRecipeAdmin',
}

export enum DataMasterViewerGroup {
  ItemMasterViewer = 'ItemMasterViewer',
  ItemCategoriesViewer = 'ItemCategoriesViewer',
  ItemCodeRequestViewer = 'ItemCodeRequestViewer',
}

export enum DataMasterAdminGroup {
  ItemMasterAdmin = 'ItemMasterAdmin',
  ItemCategoriesAdmin = 'ItemCategoriesAdmin',
  ItemSiteAssigner = 'ItemSiteAssigner',
}

export enum LapDipRequestRoles {
  LabDipRequestViewer = 'LabDipRequestViewer',
  LabDipRequestEditor = 'LabDipRequestEditor',
  LabDipRequestAdmin = 'LabDipRequestAdmin',
}

export enum LapDipRoles {
  LabDipViewer = 'LabDipViewer',
  LabDipEditor = 'LabDipEditor',
  LabDipAdmin = 'LabDipAdmin',
}

export enum TestLabDipAdminGroup {
  TestLabDipAdmin = 'TestLabDipAdmin',
}
